import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import './embed.css';

// All screen-worthy embeds (excludes tickers/prices and admin-only embeds)
const POOL = [
  '/monitor/index.html',
  '/embed/leaderboard-logo',
  '/embed/dashboard',
  '/embed/dashboard?chart=false',
  '/embed/leaderboard?limit=50&style=compact',
  '/embed/market?chart=true',
  '/embed/market?chart=false',
  '/embed/random-stocks',
  '/embed/random-detail?variant=full',
  '/embed/trades-table',
  '/embed/events-table',
  '/embed/market',
  '/embed/full-market-compact',
  '/embed/full-market-box',
  '/embed/recent-trades',
  '/embed/countdown',
  'https://komokshow.netlify.app/simulate/?broadcast=true&displayMode=video-composite',
];

function pickRandom(current) {
  let next;
  do {
    next = POOL[Math.floor(Math.random() * POOL.length)];
  } while (next === current && POOL.length > 1);
  return next;
}

const EmbedShuffle = () => {
  const [searchParams] = useSearchParams();
  const interval = parseInt(searchParams.get('interval')) || 120000; // 2 min default
  const showLogo = searchParams.get('logo') !== 'false';

  const [currentPage, setCurrentPage] = useState(() => POOL[Math.floor(Math.random() * POOL.length)]);
  const [key, setKey] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentPage(prev => pickRandom(prev));
      setKey(k => k + 1);
    }, interval);
    return () => clearInterval(timer);
  }, [interval]);

  return (
    <div className="embed-home">
      <button className="embed-fullscreen-btn embed-fullscreen-corner" onClick={() => document.documentElement.requestFullscreen?.()}>&#x26F6;</button>

      <iframe
        key={key}
        src={currentPage}
        title="Shuffle Display"
        className="embed-home-iframe"
        allowFullScreen
      />

      {showLogo && !currentPage.includes('leaderboard-logo') && (
        <div className="embed-home-logo">
          <img src="/komok_logo.webp" alt="KOMOK" />
        </div>
      )}
    </div>
  );
};

export default EmbedShuffle;
